/**
 * Lowercase, hyphenated, ASCII-safe slug for filenames.
 * Preserves digits and hyphens. Strips file extensions.
 *
 * slugify("CP12 - 18 Siskin Grove.pdf") === "cp12-18-siskin-grove"
 * slugify("EPC.pdf")                    === "epc"
 * slugify("  ")                         === "file"
 */
export function slugify(input: string): string {
  const noExt = input.replace(/\.[^./\\]+$/u, "");
  // strip Unicode combining marks (Mn = nonspacing mark) after NFKD decomposition
  const ascii = noExt.normalize("NFKD").replace(/\p{Mn}+/gu, "");
  const lower = ascii.toLowerCase();
  const dashed = lower.replace(/[^a-z0-9]+/g, "-").replace(/(^-+)|(-+$)/g, "");
  return dashed || "file";
}
